// Shared enum -> translated display label helper. Reuses the same "statuses.*" locale
// namespace that StatusBadge already relies on, so any page building its own filter-pill,
// role-badge, or activity-feed text from a raw backend enum value renders it consistently
// with the equivalent StatusBadge elsewhere on the same page, instead of showing the raw
// ALL_CAPS enum string. Falls back to the raw value if no translation key exists (identical
// fallback behavior to StatusBadge, since useLocalization().t() returns the key itself when
// a lookup misses).
export function statusLabel(t, value) {
  if (!value) return value;
  const translated = t(`statuses.${value}`);
  return translated === `statuses.${value}` ? value : translated;
}
